var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoaderNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    width: 200,
    height: 200,
    style: {
      shapeRendering: "auto",
      display: "block",
      background: "transparent"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10 50A40 40 0 0 0 90 50A40 44.8 0 0 1 10 50",
    fill: "#d00f1c",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    dur: "0.33444816053511706s",
    repeatCount: "indefinite",
    keyTimes: "0;1",
    values: "0 50 52.4;360 50 52.4"
  })), /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderNew);
export default __webpack_public_path__ + "static/media/loader-new.272167036aba0f40d0fe4b884bf1da80.svg";
export { ForwardRef as ReactComponent };